import { createContext } from 'react';
export default /*#__PURE__*/createContext({
  focusMobileFilterButton: () => {},
  mobileFilterButtonRef: null,
  setDefaultEventProperties: () => {},
  trackInteraction: () => {}
});